




/* eslint-disable no-underscore-dangle */

import Vue from 'vue';
import Axios from 'axios';
import { LOGOUT } from './use-cases/user-auth/AuthModule';
import { LOGIN } from './router/route-names';

export default Vue.extend({
  name: 'App',
  created() {
    // configure axios
    Axios.defaults.baseURL = '/api';
    Axios.interceptors.response.use(undefined, (err) => {
      // log user out if token has expired
      if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
        this.$store.dispatch(LOGOUT);
        this.$router.push({ name: LOGIN });
      }
      throw err;
    });
  },
});
